'use client';

import { useEffect, useRef } from 'react';
import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';
import { ArticlePathProvider } from '@root/contexts/ArticlePathContext';

interface Props {
  label: string;
}

export default function ArticlePageClient({ label }: Props) {
  const { cmsPage, isLoading, error } = useCmsPage(label);
  const scrolledForLabel = useRef<string | null>(null);

  // TODO: B2C-36183 Remove this after rendering article pages server side
  useEffect(() => {
    if (cmsPage && scrolledForLabel.current !== label) {
      scrolledForLabel.current = label;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [cmsPage, label]);

  if (!isLoading && error) {
    return <ErrorComponent errorCode={404} />;
  }

  return (
    <ArticlePathProvider path={label}>
      <Page cmsPage={cmsPage} />
    </ArticlePathProvider>
  );
}
